// import './_language.js';

window.addEventListener("load", function () {
    const btnBurger = document.querySelector('#pwm-ld-25-bigupdate-navigation .btn-burger');
    const dropdownMenu = document.querySelector('#pwm-ld-25-bigupdate-navigation .dropdown-menu');
    //const languageInput = document.querySelector('#pwm-ld-25-bigupdate-navigation #language');
    //const languageContainer = document.querySelector('#pwm-ld-25-bigupdate-navigation .language');
    
    if (btnBurger && dropdownMenu) {
        btnBurger.addEventListener('click', function() {
            dropdownMenu.classList.toggle('active');
            if (dropdownMenu.classList.contains('active')) {
                btnBurger.classList.add('active');
            } else {
                btnBurger.classList.remove('active');
            }
        });

        const listItems = document.querySelector('#pwm-ld-25-bigupdate-navigation .list-items');
        if (listItems) {
            listItems.addEventListener('click', function(e) {
                if (e.target.closest('a')) {
                    dropdownMenu.classList.remove('active');
                    btnBurger.classList.remove('active');
                }
            });
        }
    }
    // Xử lý click menu để chuyển slide
    function initMenuClick() {
        // Đợi swiper sẵn sàng
        if (!window.swiper || typeof window.swiper.slideTo !== 'function') {
            setTimeout(initMenuClick, 100);
            return;
        }

        // Lấy các menu items
        const menuHome = document.querySelector('#pwm-ld-25-bigupdate-navigation .list-items-home');
        const menuUpdate = document.querySelector('#pwm-ld-25-bigupdate-navigation .list-items-diemdanh');
        const menuLucky = document.querySelector('#pwm-ld-25-bigupdate-navigation .list-items-lucky');
        const menuRanking = document.querySelector('#pwm-ld-25-bigupdate-navigation .list-items-ranking');
        // Kiểm tra đang ở mobile
        function isMobile() {
            return btnBurger && btnBurger.offsetParent !== null;
        }

        // Hàm để ẩn dropdown menu trên mobile
        function hideDropdownOnMobile() {
            if (isMobile()) {
                dropdownMenu.classList.remove('active');
                btnBurger.classList.remove('active');
            }
        }

        // Thêm event listeners cho 4 menu items
        if (menuHome) {
            menuHome.addEventListener('click', function(e) {
                e.preventDefault();
                if (isMobile()) {
                    scrollToSlide(0);
                } else if (window.swiper) {
                    window.swiper.slideTo(0, 800);
                }
                hideDropdownOnMobile();
            });
        }

        if (menuUpdate) {
            menuUpdate.addEventListener('click', function(e) {
                e.preventDefault();
                if (isMobile()) {
                    scrollToSlide(1);
                } else if (window.swiper) {
                    window.swiper.slideTo(1, 800);
                }
                hideDropdownOnMobile();
            });
        }

        if (menuLucky) {
            menuLucky.addEventListener('click', function(e) {
                e.preventDefault();
                if (isMobile()) {
                    scrollToSlide(2);
                } else if (window.swiper) {
                    window.swiper.slideTo(2, 800);
                }
                hideDropdownOnMobile();
            });
        }

        if (menuRanking) {
            menuRanking.addEventListener('click', function(e) {
                e.preventDefault();
                if (isMobile()) {
                    scrollToSlide(3);
                } else if (window.swiper) {
                    window.swiper.slideTo(3, 800);
                }
                hideDropdownOnMobile();
            });
        }
    }

    // Khởi tạo menu click handlers
    initMenuClick();
});

